import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class SanitizationService {
  constructor(private apiService: ApiService) {}

  public launchWorkOrderDeduplication() {
    return this.apiService.get(`/Sanitization/LaunchWorkOrderDeduplication`);
  }

  public launchWorkOrderCategoryCheck() {
    return this.apiService.get(`/Sanitization/LaunchWorkOrderCategoryCheck`);
  }

  public launchPriorizationCheck() {
    return this.apiService.get(`/Sanitization/LaunchPriorizationCheck`);
  }

  public launchNotificationCandidatesSearch() {
    return this.apiService.get(
      `/Sanitization/LaunchNotificationCandidatesSearch`
    );
  }
}
